import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { FlyFreelyConstants } from '../constants';
import {
    CreateProjectCommand,
    ProjectDto,
    UpdateProjectCommand
} from '../model/api';
import { httpParamSerializer } from './service.helpers';

@Injectable({
    providedIn: 'root'
})
export class ProjectsService implements OnDestroy {
    private baseUrl: string;
    private changeSource = new Subject<void>();
    change$ = this.changeSource.asObservable();

    constructor(constants: FlyFreelyConstants, private http: HttpClient) {
        this.baseUrl = constants.API_URL;
    }

    ngOnDestroy() {
        this.changeSource.complete();
    }

    find(organisationId: number, archived?: boolean) {
        return this.http.get<ProjectDto[]>(`${this.baseUrl}/webapi/projects`, {
            params: httpParamSerializer({ organisationId, archived })
        });
    }

    create(command: CreateProjectCommand) {
        return this.http
            .post<ProjectDto>(`${this.baseUrl}/webapi/projects`, command)
            .pipe(tap(() => this.changeSource.next()));
    }

    update(projectId: number, command: UpdateProjectCommand) {
        return this.http
            .put<ProjectDto>(
                `${this.baseUrl}/webapi/projects/${projectId}`,
                command
            )
            .pipe(tap(() => this.changeSource.next()));
    }

    archive(projectId: number) {
        return this.http
            .put<ProjectDto>(
                `${this.baseUrl}/webapi/projects/${projectId}/archive`,
                null
            )
            .pipe(tap(() => this.changeSource.next()));
    }

    unarchive(projectId: number) {
        return this.http
            .put<ProjectDto>(
                `${this.baseUrl}/webapi/projects/${projectId}/unarchive`,
                null
            )
            .pipe(tap(() => this.changeSource.next()));
    }
}
